<script>
import BaseSimpleTable from '@/components/_base-simple-table.vue'
import dateMixin from '@/mixins/dateMixin'
import ExtendBookingConfirmationItem from '@/models/bookings/extend-booking/extendBookingConfirmationItem.js'
import VuetifyTextClass from '@/shared/constants/core/VuetifyTextClass'
import VuetifyColourClass from '@/shared/constants/core/VuetifyColourClass'
import CandidateImage from '@/components/candidate/candidate-image.vue'
import DateFormatToken from '@/shared/constants/date/DateFormatToken'
const { dddDMMMYYYY } = DateFormatToken

export default {
  components: { BaseSimpleTable, CandidateImage },
  mixins: [dateMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
    extendedBookings: {
      type: Array,
      required: true,
    },
    confirmedBookings: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    ...VuetifyTextClass,
    text: VuetifyColourClass.text,
    grey600: VuetifyColourClass.grey600,
    headers: ['date', 'booking id', 'educator', 'time', 'action'],
  }),
  computed: {
    tableData() {
      return this.extendedBookings.map(
        ({ id, candidate, startTimeLocation, endTimeLocation }) => {
          return new ExtendBookingConfirmationItem(
            id,
            candidate,
            this.formatDate(startTimeLocation, dddDMMMYYYY),
            this.formatTimesToFriendlyDuration(
              startTimeLocation,
              endTimeLocation
            )
          )
        }
      )
    },
  },
}
</script>

<template>
  <div>
    <p :class="smallBody">{{ $t('booking.extend.confirmationSubtitle') }}</p>
    <BaseSimpleTable
      :headers="headers"
      :items="tableData"
      :excluded-keys="['candidateId']"
      fixed-header
      height="350px"
    >
      <template v-slot:name-cell="{ item }">
        <div class="d-flex justify-space-between align-center w-100">
          <div class="d-flex align-center">
            <v-icon
              v-if="!item.candidateId"
              size="35"
              class="mr-4 align-unfilled-icon"
              :color="grey600"
              >mdi-account-circle</v-icon
            >
            <CandidateImage
              v-else
              :id="item.candidateId"
              size="sm"
              :full-name="item.name"
            />
            <p class="mb-0" :class="text.grey500">{{
              !item.candidateId ? $t('booking.extend.unfilled') : item.name
            }}</p>
          </div>
        </div>
      </template>
      <template v-slot:bookingId-cell="{ item }">
        <div :class="[text.blue500, smallBodyBold]">
          {{ item.bookingId }}
        </div>
      </template>
    </BaseSimpleTable>
  </div>
</template>
